export const estados = [
  "Acre",
  "Alagoas",
  "Amapá",
  "Amazonas",
  "Bahia",
  "Ceará",
  "Distrito Federal",
  "Espírito Santo",
  "Goiás",
  "Maranhão",
  "Mato Grosso",
  "Mato Grosso do Sul",
  "Minas Gerais",
  "Pará",
  "Paraíba",
  "Paraná",
  "Pernambuco",
  "Piauí",
  "Rio de Janeiro",
  "Rio Grande do Norte",
  "Rio Grande do Sul",
  "Rondônia",
  "Roraima",
  "Santa Catarina",
  "São Paulo",
  "Sergipe",
  "Tocantins",
];

export const tiposPublicacao = {
  "POSTAGEM" : 0,
  "COMENTARIO" : 1,
  "RESPOSTA" : 2,
  "POST" : 3
}

export const tiposGerenciamentoModal = {
  "NONE" : 0,
  "CRIAR" : 1,
  "EDITAR" : 2,
  "INFORMACOES" : 3,
}

export const tipoPlantio = [
  "Pessoal",
  "Organizacional",
  "Empresarial"
]

export const tipoProPlantio = [
  "Individual",
  "Profissional"
]